import { Injectable } from '@angular/core';
import { SessionStorageService } from '../session-storage/session-storage.service';
import { SessionAuthDataModel } from './session-auth-data/session-auth-data.model';
import { SessionData } from '../interfaces/session-data.interface';
import { SessionableCommonDataModel } from '../sessionable-common-data.model';

@Injectable()
export class SessionDataModel extends SessionableCommonDataModel implements SessionData {

  constructor(protected sessionStorageService: SessionStorageService,
              private _authData: SessionAuthDataModel) {
    super(sessionStorageService);
  }

  protected map<SessionDataModel>(model: SessionDataModel): any {
    return model;
  }

  protected save(setter: (model: any) => void): void {
    super.save(setter);
  }

  public populate<SessionDataModel>(model?: SessionDataModel): SessionDataModel {
    this._authData.populate(model ? model['_authData'] : null);
    return this as any;
  }

  public set authData(value: SessionAuthDataModel) {
    this._authData = value;
    this.save(x => x._authData = value);
  }

  public get authData(): SessionAuthDataModel {
    return this._authData;
  }

  public clear(): void {
    SessionStorageService.deleteHydrationKeys();
    SessionStorageService.deleteMortgageApplicationProgressData();
    SessionStorageService.deletePersonalLoanApplicationProgressData();
    this.sessionStorageService.removeItem(this.key);
    this.sessionStorageService.setItem(this.key, this.populate());
  }
}
